import React from 'react';

import * as s from './styles';
import { validateStringOrFunction } from '../../../util/general';


const SafetyList = ({ showSsiJobCode, dataList, className="" }) => {
  
  return (
    <s.MultiBrandSafetyListContainer className={className}>
      {
        dataList.warningList ?  <s.MultiBrandSafetyItem>
        <s.MultiBrandSafetyWarningTitle>
          { validateStringOrFunction(dataList.warningList.title) }
        </s.MultiBrandSafetyWarningTitle>

        <s.MultiBrandSafetyWarningList>

          {dataList.warningList.items.map((item, i) => (
            <li key={i}>{validateStringOrFunction(item)}</li>
          ))}

        </s.MultiBrandSafetyWarningList>
      </s.MultiBrandSafetyItem> : null
      }
     

      {dataList.sections.map((sectionObj, i) => (
        <s.MultiBrandSafetyItem key={i}>
          { sectionObj.title && <s.MultiBrandSafetyItemTitle>
            { validateStringOrFunction(sectionObj.title) }
          </s.MultiBrandSafetyItemTitle> }

          { sectionObj.subTitle ?  (
                <s.MultiBrandSafetyItemList>
                  {sectionObj.subTitle.map((item, i) => (
                    <React.Fragment key={i}>
                      {item.titleHeading && <s.MultiBrandSafetySubItemTitle className={className}>{validateStringOrFunction(item.titleHeading)}</s.MultiBrandSafetySubItemTitle>}
                      {item.italicHeading && <s.MultiBrandSafetySubItemItalicTitle>{validateStringOrFunction(item.italicHeading)}</s.MultiBrandSafetySubItemItalicTitle>}
                      {item.content.map((point, j) => (
                        <li key={j}>{validateStringOrFunction(point)}</li>
                      ))}
                    </React.Fragment>
                  ))}
                </s.MultiBrandSafetyItemList>
            )
          
          
           : <s.MultiBrandSafetyItemList>
            {sectionObj.items.map((item, i) => (
            
              <li key={i}>{validateStringOrFunction(item)}</li>
            ))}

          </s.MultiBrandSafetyItemList>
          
          }

        </s.MultiBrandSafetyItem>
      ))}
      {
        dataList.finalWarning && <s.MultiBrandFinalWarning className={className}>{validateStringOrFunction(dataList.finalWarning)}</s.MultiBrandFinalWarning>
      }
      {/* <s.MultiBrandFinalWarning
        dangerouslySetInnerHTML={{__html: dataList.finalWarning}}
      /> */}

      {showSsiJobCode &&
        <s.MultiBrandSafetyJobCode>
          { validateStringOrFunction(dataList.safetyJobCode) }
        </s.MultiBrandSafetyJobCode>
      }

    </s.MultiBrandSafetyListContainer>
  );
};


export default SafetyList;
